<template>
  <div class="">
    <div>
      <input
        ref="fileToUpload"
        class="input-file"
        :type="type"
        tabIndex="-1"
        accept="image/jpeg,image/x-png,image/gif,application/x-zip-compressed"
        name="file"
        @change="fileSelected()"
      />
      <mu-button small color="primary" @click="chooseFile">选择文件</mu-button>
    </div>
    <!-- <mu-button type="button" class="btn btn-upload" @click="handleUpload">
      上传
    </mu-button> -->
  </div>
</template>

<script>
import { useApi } from '@/hooks/useApi'
export default {
  name: 'Upload',
  components: {},
  props: {
    max: {
      type: Number,
      default: 8,
    },
    maxSize: {
      type: Number,
      default: 20000,
    },
    type: {
      type: String,
      default: 'file',
    },
  },
  data() {
    return {
      // personInfo: {},
      fileList: [],
      formData: new FormData(),
    }
  },
  methods: {
    chooseFile() {
      this.$refs.fileToUpload.click()
    },
    fileSelected() {
      var that = this
      let files = this.$refs.fileToUpload.files
      // console.log("文件", files);
      if (files && files.length) {
        var reader = new window.FileReader()
        // 图片大小 20MB
        var fileSize = this.maxSize * 1024
        for (let file of files) {
          reader.readAsDataURL(file)
          reader.onload = function (e) {
            // console.log('文件流', e.target.result)
            if (e.target.result.length > fileSize) {
              that.$refs.fileToUpload.value = ''
              that.$confirm('文件超过限制大小', '提示')
            } else {
              that.handleUpload(files)
            }
          }
        }
      }
    },
    // 上传成功
    uploadComplete() {
      // this.$refs.fileToUpload.value = ''
    },
    deleteFile(index) {
      this.$confirm('确定删除文件吗？', '提示').then(({ result }) => {
        if (result) {
          this.fileList.splice(index, 1)
          this.$emit('uploaded', this.fileList)
        }
      })
    },
    clear() {
      this.fileList = []
      this.$emit('uploaded', this.fileList)
    },
    handleUpload(fd) {
      console.log(fd)
      if (this.fileList.length >= this.max) {
        this.$confirm('附件数量不可超过' + this.max + '个', '提示')
      } else {
        useApi(
          {
            url: '/v1/api/upload',
          },
          {
            files: fd,
            upload_type: 'attachment',
          }
        )
          .then(({ data }) => {
            this.fileList.push({
              name: data.info.name,
              id: data.info.id,
            })
            this.$emit('uploaded', this.fileList)
          })
          .catch(() => {
            this.$confirm('文件上传错误', '提示')
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.center-container {
  background-color: #fff;
  height: 100vh;
  width: 100vw;
  // display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
}

.input-file {
  display: none;
}
.btn-chooseFile {
  background: grey;
  color: #fff;
  display: inline-block;
  padding: 8px;
  border-radius: 4px;
}
</style>
